import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CreditActions from "../../../store/credit/actions";
import { ApplicationState } from "../../../store";
import moment from "moment-timezone";
import CreditScoreType from "./CreditScoreType";
import CreditExpired from "../CreditExpired";
import CreditStatus from "../CreditStatus";
import { getScoreRating, getScoreStatus } from "../../../util/credit";
import { getActiveServiceCode } from "../../../util/CommonServices";
import { ezsServiceIds } from "../../../config/UserServicesList";
import TransunionLogo from "../../../Assets/images/logo_transunion.png";
import { useTranslation } from "react-i18next";

const CreditScoreAllBureau = () => {
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const dailyRefreshableCreditServiceIds = [ezsServiceIds.tuDailyCreditReportWithScore, ezsServiceIds.tuDailyCreditReport];
    const dailyServiceCode = getActiveServiceCode(dailyRefreshableCreditServiceIds);
    const requestDailyCreditScore = () => dispatch(CreditActions.actionCreators.requestDailyCredit(false, dailyServiceCode));
    const isTUUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userInfo?.isTUUser);
    const creditScores = useSelector((state: ApplicationState) => {
        if (state.dailyCreditScoreData.dailyCreditData != null && state.dailyCreditScoreData.dailyCreditData.scores != null) {
            state.dailyCreditScoreData.dailyCreditData.scores.forEach(function (score, index) {
                let scoreDesc = getScoreRating(score["risk-score"], tLang);
                score["score-desc"] = scoreDesc;

                if (!state.dailyCreditScoreData.dailyCreditData.IsIDFUser && !isTUUser && score["inquiry-date"] == null) {
                    // for EZS user dont show updated date.
                    //score["inquiry-date"] = state.creditScoreData.creditData["update-date"];
                } else if (!score["inquiry-date"].includes("/")) {
                    score["inquiry-date"] = moment(score["inquiry-date"], "YYYY-MM-DD").format("MM/DD/YYYY");
                }
            });
        }
        return state.dailyCreditScoreData.dailyCreditData;
    });
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const isLoading = useSelector((state: ApplicationState) => {
        return state.dailyCreditScoreData.isLoading;
    });

    const ensureDataFetched = () => {
        requestDailyCreditScore();
    };

    useEffect(ensureDataFetched, []);

    const renderMessageScreen = () => {
        if ((creditScores.IsIDFUser || isTUUser) && (creditScores["tu-status"] === "tu-thin-error" || creditScores["tu-status"] === "tu-down")) {
            return <CreditStatus status={creditScores["tu-status"]} />;
        }  else if ((creditScores.IsIDFUser || isTUUser) && creditScores.IsScoreExpired) {
            return <CreditExpired />;
        } else {
            return renderScoreScreen();
        }
    };

    const getCreditBureauLogo = (bureau: string) => {
        bureau = bureau.toLowerCase();
        let creditBureauLogo;
        switch (bureau) {
            case "transunion":
                creditBureauLogo = TransunionLogo;
                break;
        }

        return creditBureauLogo;
    };

    const renderScoreScreen = () => {
        return (
            <ul className="credit-bureau-list">
                {creditScores.scores &&
                    creditScores.scores.map((score) => (
                        <CreditScoreType
                            key={score.type}
                            scoreValue={score["risk-score"]}
                            scoreRating={score["score-desc"]}
                            population={score["population-rank"]}
                            title={score.abbreviation}
                            logo={getCreditBureauLogo(score.abbreviation)}
                            updated={score["inquiry-date"]}
                            isIDFUser={creditScores.IsIDFUser}
                            status={getScoreStatus(score["risk-score"])}
                            isTUUser={isTUUser}
                        />
                    ))}
            </ul>
        );
    };

    return (
        <React.Fragment>
            {creditScores != null ? (
                <React.Fragment>
                    <div>{renderMessageScreen()}</div>
                </React.Fragment>
            ) : (
                <React.Fragment>{isLoading ? <div className="box loading"></div> : ""}</React.Fragment>
            )}
        </React.Fragment>
    );
};

export default CreditScoreAllBureau;
